import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { Discount } from 'src/features/discounts/utils/types';
import { DiscountFormSchemaValues } from 'src/features/discounts/utils/formSchema';

const RESOURCE = '/discounts/discount/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: DiscountFormSchemaValues): Promise<Discount> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateDiscount };
